module.exports = __webpack_public_path__ + "static/media/400139_01.387074ba.png";